<template>
  <div class="modal offer-modal skin-modal offer-details-modal">
    <div class="overlay" @click="closeOfferDetailsModal"></div>
    <div class="wrapper">
      <img class="close" @click="closeOfferDetailsModal" src="@/assets/close.svg" />
      <div class="container">
        <form>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>Details</b>
              </div>
              <div class="form-fields-wrapper">
                <div class="offer-wrapper">
                  <div class="row">
                    <div class="title">Skin name</div>
                    <div class="desc">{{ orderToView.title }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Quality</div>
                    <div class="desc">
                      {{ orderToView.quality }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="title">Desired Price</div>
                    <div class="desc">
                      <b>
                        {{ orderToView.user_price }}
                        {{ orderToView.currency }}</b
                      >
                    </div>
                  </div>
                  <div v-if="orderToView.status == 'offer'" class="row row-spec">
                    <div class="title">Our price</div>
                    <div class="desc">
                      <b>
                        {{ orderToView.service_price }}
                        {{ orderToView.currency }}</b
                      >
                    </div>
                  </div>

                  <div v-if="orderToView.status == 'offer'" class="buttons">
                    <div class="button red" @click="decline">
                      <span>Decline</span>
                    </div>
                    <div class="button orange-btn" @click="accept">
                      <span>Accept</span>
                    </div>
                  </div>

                  <div v-else-if="orderToView.status == 'ready_for_payout'" class="buttons">
                    <div class="button orange-btn" @click="requestPayout">
                      <span>Payout</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'OfferDetailsModal',
    props: [],
    components: {},
    data: function () {
      return {}
    },
    computed: {
      ...mapState('offers', ['orderToView']),
      ...mapState('app', ['currency'])
    },
    methods: {
      ...mapActions('offers', ['declineOffer', 'acceptOffer']),
      ...mapActions('modals', ['closeOfferDetailsModal', 'openAcceptOfferModal']),

      decline() {
        this.declineOffer(this.orderToView.id)
      },

      accept() {
        this.acceptOffer(this.orderToView.id)
      },

      requestPayout() {
        this.openAcceptOfferModal()
      }
    }
  }
</script>
